module.exports = __webpack_public_path__ + "img/covid.c8d0e108.svg";